import { createFileRoute, notFound } from '@tanstack/react-router'

/**
 * The modal slot's root: the parent of every dialog route, which render through `<ModalSlotOutlet />` over the
 * page, never as one. Their paths are the RFC's fully qualified slot paths (`/@modal/jobs/$jobId/edit`) so the
 * router can match, type and preload them; a visit to one as a PAGE is a 404 — docs/notes/app/dialog-routes.md.
 */
export const Route = createFileRoute('/@modal')({
  beforeLoad: ({ cause }) => {
    // oxlint-disable-next-line typescript/only-throw-error -- the router's own not-found signal, not an error
    if (cause !== 'preload') throw notFound()
  },
})
